import { Injectable, InjectionToken } from "@angular/core";
import { PriceTemplateData } from "shared/components/shared/price/template-data/price-template-data.model";
import { ProductComplexPriceDto } from "shared/services/INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IPriceTemplateService {

  public abstract productPriceTemplateGetByProductComplexPrice(productComplexPriceList: ProductComplexPriceDto[]): PriceTemplateData;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IPriceTemplateServiceToken = new InjectionToken<IPriceTemplateService>('IPriceTemplateService');
